import React, {useEffect, useState} from 'react';
import {useLoaderData} from "react-router";
import AlertMessages from "../../../../components/messages/alert-message.js";
import projectUtils from "../../../../utils/project-utils.js";
import myUserService from "../../../../services/web/my-user-service.js";
import {toast} from "react-toastify";
import {Card} from "../../../../components/card/card.jsx";
import {FaArrowLeft} from "react-icons/fa";
import Button from "../../../../components/button/button.jsx";
import InputPassword from "../../../../components/input/input-password.jsx";

const initialPassword = {
    current: "",
    new: "",
    confirm: ""
}

const MyUserPassword = ({refetch, setTarget, setIsLoading}) => {
    const loaderData = useLoaderData();

    const [state, setState] = useState(initialPassword);
    const [isNewPasswordValid, setIsNewPasswordValid] = useState(false);
    const [isValid, setIsValid] = useState(false)

    useEffect(() => {
        return () => setState(initialPassword);
    }, []);

    const handlePassword = ({target: {id, value}}) => {
        setState(prevState => {
            const updated = { ...prevState, [id]: value };

            if (id === "new") {
                validateNewPassword(value);
            }

            return updated;
        });
    };

    const submit = () => {
        if (!isValid) {
            projectUtils.swalErrorMessage("", "A senha não atende aos requisitos de segurança.")
            return
        }

        if (!state.current.trim()) {
            projectUtils.swalErrorMessage("", AlertMessages["missing.currentPassword"], "Ok");
            return;
        }

        if (!state.confirm.trim()) {
            projectUtils.swalErrorMessage("", AlertMessages["missing.confirmPassword"], "Ok");
            return;
        }

        if (!state.new.trim()) {
            projectUtils.swalErrorMessage("", AlertMessages["missing.newPassword"], "Ok");
            return;
        }

        if (state.new.trim() !== state.confirm.trim()) {
            projectUtils.swalErrorMessage("", AlertMessages["password.confirm"], "Ok");
            return;
        }

        setIsLoading(true)

        const formData = new FormData();
        formData.append("current_password", state.current);
        formData.append("new_password", state.new);

        myUserService.updatePassword(formData)
            .then(() => {
                toast.success("Salvo com sucesso");
                setTarget("info");
                refetch();
            })
            .catch(error => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
            .finally(() => setIsLoading(false))
    }

    const validateNewPassword = (value) => {
        const val = projectUtils.removeAccents(value.trim());

        const lower = /[a-z]/.test(val);
        const upper = /[A-Z]/.test(val);
        const number = /[0-9]/.test(val);
        const special = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(val);
        const length = val.length >= 8;

        setIsNewPasswordValid(lower && upper && number && special && length);
    };

    const isFormValid = (
        state.current &&
        state.new &&
        state.confirm &&
        state.new === state.confirm &&
        isNewPasswordValid
    );


    return (
        <Card>
            <Card.Body>
                <h3 className="flex gap-2 items-center">
                    <FaArrowLeft className="cursor-pointer font-normal" onClick={() => setTarget("info")}/>
                    Alterar senha
                </h3>

                <div className="p-3 grid grid-cols-12 gap-3">
                    <InputPassword
                        id="current"
                        value={state.current}
                        label="Senha atual *"
                        onChange={handlePassword}
                        col={"col-span-4"}
                        setIsValid={setIsValid}
                    />

                    <InputPassword
                        id="new"
                        value={state.new}
                        label="Nova senha *"
                        onChange={handlePassword}
                        target="password"
                        passwordComplexity={loaderData?.passwordComplexity ?? false}
                        col={"col-span-4"}
                        setIsValid={setIsValid}
                    />

                    <InputPassword
                        id="confirm"
                        value={state.confirm}
                        label="Confirmação de senha *"
                        onChange={handlePassword}
                        password={state.new}
                        col={"col-span-4"}
                    />
                </div>

                <div className="flex justify-end p-[15px]">
                    <Button onClick={submit} disabled={!isFormValid} actionFeedbackType='save'>

                        Salvar
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default MyUserPassword;